import { BasicPayload } from ".";

export type PromptPayloadType = BasicPayload & {
  prompts: PromptRequest[];
};

export type ScriptLogPayloadType = {
  logs: string;
};

export type RequestOauthPayloadType = {
  request_id: string;
  title: string;
  description: string;
  auth_code_url: string;
};

export type DonePayloadType = {
  execution_time_ms: number;
};

export type MetadataPayloadType = {
  expires_in_ms: number;
};

export type FinishedPayloadType = {};

export type UserNetworkPayloadType = {
  proxy_url: string;
};

export type CdpTargetPayloadType = {
  websocket_debugger_page_url: string;
};

export type UserNetworkDonePayloadType = {};

export type PromptType<T extends PromptTypeKey = PromptTypeKey> =
  PromptTypeMap[T];

export type PromptRequest<T extends PromptTypeKey = PromptTypeKey> = {
  key: string;
  label: string;
  description?: string;
  required?: boolean;
  type: T;
  attributes: PromptType<T>;
  error?: string;
};

export type PromptTypeMap = {
  [PromptTypeKey.TEXT]: PromptTextType;
  [PromptTypeKey.PASSWORD]: PromptPasswordType;
  [PromptTypeKey.CODE]: PromptCodeType;
  [PromptTypeKey.NUMBER_CODE]: PromptNumberCodeType;
  [PromptTypeKey.SELECT]: PromptSelectType;
  [PromptTypeKey.CHECKBOX]: PromptCheckboxType;
  [PromptTypeKey.LOGIN]: PromptLoginType;
};

export enum PromptTypeKey {
  TEXT = "text",
  PASSWORD = "password",
  CODE = "code",
  NUMBER_CODE = "number_code",
  SELECT = "select",
  CHECKBOX = "checkbox",
  LOGIN = "login",
}

/**
 * Begin Specific Prompt Types
 */
export type PromptTextType = {
  min_length?: number;
  max_length?: number;
  value?: string;
  placeholder?: string;
};

export type PromptPasswordType = {};

export type PromptCodeType = {
  length?: number;
};

export type PromptNumberCodeType = {
  length?: number;
};

export type PromptCheckboxType = {
  options: string[];
  multiple?: boolean;
  selected?: string[];
  min?: number;
  max?: number;
};

export type PromptSelectType = {
  options: string[];
  selected?: string[];
};

export interface LoginProvider {
  id: LoginProviderID;
  label: string;
}
export interface PromptLoginType {
  providers: LoginProvider[];
}

export enum LoginProviderID {
  CREDENTIALS = "credentials",
  GOOGLE = "google",
}
